export default __webpack_public_path__ + "static/media/ambient-bright-purple-red.a7ec7b69.jpg";